export default __webpack_public_path__ + "static/google-play-badge (2)@3x-6697c61f4873a46f25e6fa2d116487b7.svg";